/**
 * MobileHeader Component for LOOPINO AI Platform
 * Main header component for mobile interface with profile and settings
 */

import React, { useCallback } from 'react';
import './MobileHeader.css';
import ProfileIcon from './ProfileIcon';
import AIBattery from './AIBattery';
import LoopineLogo from '../../../assets/images/LOOPINO-logo.svg';

const MobileHeader = ({ 
  currentScreen = 'posts',
  onNavigate,
  onProfileClick,
  onBatteryClick,
  onLogoClick,
  isRegenerating = false,
  homeScreen = 'posts',
  batteryScreen = 'battery',
  profileScreen = 'settings'
}) => {
  const navigate = useCallback((targetScreen) => {
    if (typeof onNavigate === 'function') {
      onNavigate(targetScreen, { source: 'header' });
    }
  }, [onNavigate]);

  const handleProfileClick = useCallback((companyData) => {
    console.log('[MobileHeader] Profile clicked:', companyData);
    if (typeof onProfileClick === 'function') {
      onProfileClick(companyData);
    }
    navigate(profileScreen);
  }, [navigate, onProfileClick, profileScreen]);

  const handleBatteryClick = useCallback((batteryData) => {
    console.log('[MobileHeader] Battery clicked:', batteryData);
    if (typeof onBatteryClick === 'function') {
      onBatteryClick(batteryData);
    }
    navigate(batteryScreen);
  }, [batteryScreen, navigate, onBatteryClick]);

  const handleLogoClick = useCallback(() => {
    console.log('[MobileHeader] Logo clicked, navigating to home');
    if (typeof onLogoClick === 'function') {
      onLogoClick();
      return;
    }
    navigate(homeScreen);
  }, [homeScreen, navigate, onLogoClick]);

  return (
    <header className="mobile-header">
      {/* Left Side - Profile Icon */}
      <ProfileIcon onProfileClick={handleProfileClick} />

      {/* Center - LOOPINO Logo */}
      <div className="mobile-header-center" onClick={handleLogoClick}>
        <img 
          src={LoopineLogo} 
          alt="LOOPINO" 
          className="mobile-header-logo"
        />
      </div>

      {/* Right Side - AI Battery */}
      <div className="mobile-header-actions">
        {/* AI Battery */}
        <AIBattery 
          onBatteryClick={handleBatteryClick}
          showStatus={false}
          isRegenerating={isRegenerating}
        />
      </div>
    </header>
  );
};

export default MobileHeader; 
